export default () => ['@hrbotfactory.com']